var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-to-link-wrapper"},[_c('a',{staticClass:"scroll-to-link",class:this.classes,attrs:{"href":_vm.target},on:{"click":function($event){$event.preventDefault();return _vm.didSelectLink()}}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib?{}!./scripts/vue/ScrollToLink.vue?vue&type=template&id=3a74aa39&
// module id = 201
// module chunks = 0